var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBomb = function SvgBomb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.584 91.666c17.258 0 31.25-13.99 31.25-31.25 0-17.258-13.992-31.25-31.25-31.25-17.26 0-31.25 13.992-31.25 31.25 0 17.26 13.99 31.25 31.25 31.25Z",
    stroke: "currentColor",
    strokeWidth: 8.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.834 62.5c0-11.506 9.327-20.834 20.833-20.834M71.65 9.349V4.166M85.416 14.74l3.665-3.664m-3.822 31.093 3.665 3.664M57.83 14.74l-3.665-3.664M90.651 28.35h5.182m-32.83 8.648L75 25",
    stroke: "currentColor",
    strokeWidth: 8.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgBomb;